<script setup lang="ts">
import { ComponentSpinner, StackLayout, TypographyItem } from '@rfc/rfc-components-library'
import { EColors } from '@rfc/rfc-components-library/types'
import { EDebounceTime } from '@rfc/rfc-components-library/utils'
import { ref } from 'vue'
import eventApi from '../../../services/event.service'

type Props = {
    eventId: number
    checkpointId: number
    deviceId: number
}
const props = defineProps<Props>()

const loading = ref(false)
const detectionsCount = ref<string>()
const debounceTimeout = ref<NodeJS.Timeout>()
const hideDetections = ref(true)
const handleMouse = (value: boolean) => {
    hideDetections.value = value
    detectionsCount.value = undefined
    clearTimeout(debounceTimeout.value)
    if (!value) {
        loading.value = true
        debounceGetDetections()
    }
}

const debounceGetDetections = () => {
    debounceTimeout.value = setTimeout(
        () =>
            eventApi
                .getDeviceDetectionsCount(props.eventId, props.checkpointId, props.deviceId)
                .then(res => (detectionsCount.value = (res.count ?? undefined)?.toString()))
                .finally(() => (loading.value = false)),
        EDebounceTime.ONE_SECOND
    )
}
</script>

<template>
    <div
        @mouseenter="handleMouse(false)"
        @mouseleave="handleMouse(true)"
        class="pointer-events-auto px-4 py-1">
        <StackLayout class="px-1 py-1 detections-count-typography">
            <TypographyItem v-if="hideDetections" label="Voir le nombre de détections" />

            <StackLayout v-else :gap="8">
                <TypographyItem :label="$t('device.checkpoints.detectionsCount')" />
                <ComponentSpinner
                    :loading="!!loading"
                    size="20"
                    indeterminate
                    :color="EColors.PRIMARY" />
                <TypographyItem v-if="!loading" :label="detectionsCount ?? $t('common.unknown')" />
            </StackLayout>
        </StackLayout>
    </div>
</template>

<style scoped lang="scss">
.detections-count-typography {
    border: 1px solid $grey-shadow;
    border-radius: 4px;
    box-shadow: 0px 0px 4px $grey-shadow;
    &:hover {
        border: 1px solid rgba(var(--v-theme-primary));
        box-shadow: 0px 0px 4px rgba(var(--v-theme-primary));
    }
}
</style>
